module.exports = __webpack_public_path__ + "img/width_left.ec1038b0.svg";